import React from 'react';


function SideBar(props) {


return (
  <>
    <div class="discuss-list-sidebar">
                               <div class="discuss-list--head">
                                 <span class="title">همه بحث و گفتگوها</span> 
                                 <i aria-hidden="true" class="fas fa-angle-down"></i>
                                 </div> 
                                 <ul><li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=mydiscuss">
                            گفتگو&zwnj;های من
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=private_discuss">
                            گفتگو&zwnj;های خصوصی
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=all">
                            همه بحث و گفتگوها
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=popular">
                            پربازدیدترین ها
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=oldest">
                            قدیمی ترین ها
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=discuss">
                            پربحث ترین ها
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=with-reply">
                            پاسخ داده شده
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=no-reply">
                            بدون پاسخ
                        </a></li> <li><i aria-hidden="true" class="fas fa-circle"></i> <a href="/discuss?type=best-reply">
                            با بهترین پاسخ
                        </a></li></ul></div>   
  </>
) 
}

export default SideBar;